import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Clients.css';

const formatBangladeshPhone = (value) => {
  const digits = value.replace(/\D/g, '');
  const normalized = digits.startsWith('880') ? digits.slice(2) : digits;
  if (normalized.length === 11 && normalized.startsWith('01')) {
    return `${normalized.slice(0, 5)}-${normalized.slice(5)}`;
  }
  return value;
};

const toInternationalPhone = (formatted) => {
  const digits = formatted.replace(/\D/g, '');
  if (digits.startsWith('880')) {
    return `+${digits}`;
  }
  if (digits.startsWith('0')) {
    return `+88${digits}`;
  }
  return `+88${digits}`;
};

function Clients() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    clientName: '',
    email: '',
    address: '',
    city: '',
    zipCode: '',
    phone: '',
    driverPhone: '',
    appPassword: '',
  });
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    if (field === 'phone' || field === 'driverPhone') {
      setForm((prev) => ({
        ...prev,
        [field]: formatBangladeshPhone(value),
      }));
      return;
    }

    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus('');
    setError('');

    const confirmMessage = `Please confirm the client details before saving:\n\n` +
      `Name: ${form.clientName}\nEmail: ${form.email}\nPhone: ${form.phone}\nDriver Phone: ${form.driverPhone}\nAddress: ${form.address}\nCustomer App: ${form.appPassword ? 'Enabled' : 'Not Enabled'}`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    try {
      const payload = {
        clientName: form.clientName.trim(),
        email: form.email.trim(),
        address: form.address.trim(),
        city: form.city.trim(),
        zipCode: form.zipCode.trim(),
        phone: toInternationalPhone(form.phone),
        driverPhone: toInternationalPhone(form.driverPhone),
        appUsername: form.email.trim() || undefined,
        appPassword: form.appPassword.trim() || undefined,
        mobileAccessEnabled: Boolean(form.email.trim() && form.appPassword.trim()),
      };

      const token = localStorage.getItem('token');
      await axios.post('/api/clients', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setStatus('Client saved successfully.');
      setForm({
        clientName: '',
        email: '',
        address: '',
        city: '',
        zipCode: '',
        phone: '',
        driverPhone: '',
        appPassword: '',
      });

      // Auto-navigate back to clients list after 1.5 seconds
      setTimeout(() => {
        navigate('/clients');
      }, 1500);
    } catch (err) {
      setError(
        err.response?.data?.error ||
          err.response?.data?.message ||
          'Failed to save client.'
      );
    }
  };

  return (
    <div className="client-page">
      <button className="back-link" onClick={() => navigate('/clients')}>
        New Client
      </button>
      <div className="client-card">
        <p className="client-note">Enter client details below. Phone numbers are shown as <strong>01711-540216</strong>, and +88 is added internally.</p>

        <form className="client-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Client Name</label>
            <input value={form.clientName} onChange={handleChange('clientName')} placeholder="Client name" required />
          </div>

          <div className="form-row">
            <label>Email</label>
            <input type="email" value={form.email} onChange={handleChange('email')} placeholder="Email address" />
          </div>

          <div className="form-row">
            <label>Address</label>
            <input value={form.address} onChange={handleChange('address')} placeholder="Street address" />
          </div>

          <div className="form-grid">
            <div className="form-row">
              <label>City</label>
              <input value={form.city} onChange={handleChange('city')} placeholder="City" />
            </div>
            <div className="form-row">
              <label>Zip Code</label>
              <input value={form.zipCode} onChange={handleChange('zipCode')} placeholder="Zip code" />
            </div>
          </div>

          <div className="form-grid">
            <div className="form-row">
              <label>Client Phone</label>
              <input value={form.phone} onChange={handleChange('phone')} placeholder="01711-540216" required />
            </div>
            <div className="form-row">
              <label>Driver Phone</label>
              <input value={form.driverPhone} onChange={handleChange('driverPhone')} placeholder="01711-540216" required />
            </div>
          </div>

          <div className="form-row">
            <label>Customer App Password</label>
            <input
              type="password"
              value={form.appPassword}
              onChange={handleChange('appPassword')}
              placeholder="Leave blank if no customer app account"
            />
            <small className="client-subnote">
              If email and password are filled, customer app account will be created using the email as username.
            </small>
          </div>

          {error && <div className="form-error">{error}</div>}
          {status && <div className="form-success">{status}</div>}

          <button type="submit" className="save-btn">Save Client</button>
        </form>
      </div>
    </div>
  );
}

export default Clients;
